import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_131_3679",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_131_3679)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12 13.0543L6.92689 18.1274C6.78844 18.2658 6.6144 18.3367 6.40479 18.3399C6.19519 18.3431 6.01795 18.2723 5.87309 18.1274C5.7282 17.9825 5.65576 17.8069 5.65576 17.6005C5.65576 17.3941 5.7282 17.2184 5.87309 17.0736L10.9462 12.0005L5.87309 6.92737C5.73462 6.78892 5.66379 6.61489 5.66059 6.40527C5.65737 6.19568 5.7282 6.01844 5.87309 5.87357C6.01795 5.72869 6.19359 5.65625 6.39999 5.65625C6.60639 5.65625 6.78202 5.72869 6.92689 5.87357L12 10.9466L17.0731 5.87357C17.2115 5.73511 17.3856 5.66427 17.5952 5.66107C17.8048 5.65786 17.982 5.72869 18.1269 5.87357C18.2718 6.01844 18.3442 6.19407 18.3442 6.40047C18.3442 6.60687 18.2718 6.78251 18.1269 6.92737L13.0538 12.0005L18.1269 17.0736C18.2654 17.212 18.3362 17.3861 18.3394 17.5957C18.3426 17.8053 18.2718 17.9825 18.1269 18.1274C17.982 18.2723 17.8064 18.3447 17.6 18.3447C17.3936 18.3447 17.218 18.2723 17.0731 18.1274L12 13.0543Z",
			fill: "currentColor"
		})
	})]
});
export { SvgClose as ReactComponent };
